module.exports = __webpack_public_path__ + "img/iphone.e84463b.png";